import type {
	FosfatagemProductResult,
	FosfatagemResult,
	ResultTableRow,
} from '../../../recommendations/types';

export interface AdubacaoProductResponse {
	productId?: string;
	dose?: number;
	formaValue?: number;
	N?: number;
	P2O5?: number;
	K2O?: number;
}

export interface AdubacaoResponse {
	products?: AdubacaoProductResponse[];
	K?: number;
	satK?: number;
	Pm1?: number;
}

const numberString = (value: unknown): string => {
	if (value === null || value === undefined || value === '') return '';
	const numeric = Number(value);
	return Number.isFinite(numeric) ? String(numeric) : String(value);
};

const row = (param: string, unit: string, after: unknown): ResultTableRow => ({
	param,
	unit,
	current: '—',
	range: '—',
	after: numberString(after) || '—',
});

export const mapFosfatagemResponse = (data: AdubacaoResponse): FosfatagemResult => {
	const products: FosfatagemProductResult[] = (data.products ?? [])
		.filter((product) => !!product.productId)
		.map((product) => ({
			productId: product.productId ?? '',
			dose: numberString(product.dose),
			formaValue: numberString(product.formaValue),
			N: numberString(product.N),
			P2O5: numberString(product.P2O5),
			K2O: numberString(product.K2O),
		}));
	const [primary, complementary] = products;
	const sum = (key: 'N' | 'P2O5' | 'K2O') =>
		numberString(products.reduce((total, product) => total + Number(product[key] || 0), 0));

	return {
		ajuste: {
			dose: primary?.dose ?? '',
			doseSecundaria: primary?.formaValue ?? '',
			doseComplementar: complementary?.dose ?? '',
			doseSecundariaComplementar: complementary?.formaValue ?? '',
		},
		products,
		N: sum('N'),
		P2O5: sum('P2O5'),
		K2O: sum('K2O'),
		table: [
			row('P-M1', 'mg/dm³', data.Pm1),
			row('K+', 'mg/dm³', data.K),
			row('Sat. K', '%', data.satK),
		],
	};
};
